export default {
  UNKNOWN_ERROR_CUSTOMER_REGISTRATION: "UNKNOWN_ERROR_CUSTOMER_REGISTRATION",
  UNKNOWN_ERROR_DURING_LOGIN: "UNKNOWN_ERROR_DURING_LOGIN",
  GRAPHQL_MUTATION_ERROR: "GRAPHQL_MUTATION_ERROR",
  GRAPHQL_QUERY_ERROR: "GRAPHQL_QUERY_ERROR",
  PEOPLE_BY_CITY_AND_PROFESSION_ASYNC_DATA_ERROR:
    "PEOPLE_BY_CITY_AND_PROFESSION_ASYNC_DATA_ERROR",
  LOGIN_MISMATCH: "LOGIN_MISMATCH",
};
